import { ConfirmUserRequest, MyUser } from "@/types/breeze/User";
import { BaseService } from "../BaseService";

export class UserInviteService extends BaseService {
  public async getUserByInviteToken(
    tenantId: number,
    token: string,
  ): Promise<MyUser> {
    return this.getRequest(`/org/${tenantId}/users/invites/${token}`, false);
  }

  public async confirmUserByInviteToken(
    tenantId: number,
    token: string,
    request: ConfirmUserRequest,
  ): Promise<void> {
    return this.postRequest(
      `/org/${tenantId}/users/invites/${token}`,
      request,
      "",
      false,
      true,
    );
  }
}

export const userInviteService = new UserInviteService();
